import { get } from '@/services/httpMethods'
import type { Department } from '@/types/doctor'

/** Public department list used to populate the website appointment form. */
export function fetchDepartments() {
  return get<Department[]>('/departments', {
    params: { page: 1, limit: 100, showOnWebsite: 'true' },
  })
}
